export const addPinnedVideoFunc = (
  p: any,
  pinnedVideosData: any,
  cb: (pinnedVideos: any) => void,
) => {
  try {
    if (p.track?.kind === 'video') {
      const pinnedVideos = [...pinnedVideosData];
      const index = pinnedVideos.findIndex((i) => i.sid === p.sid);
      const dominantIndex = pinnedVideos.findIndex((i) => i.pinned === true);
      if (dominantIndex >= 0) {
        const dominantSpeaker = pinnedVideos[dominantIndex];
        // replace the dominant speaker, first remove it
        if (dominantSpeaker.sid !== p.sid) {
          pinnedVideos.splice(dominantIndex, 1);
        }
      }

      if (index >= 0) {
        pinnedVideos[index] = p;
      } else {
        pinnedVideos.push(p);
      }
      cb(pinnedVideos);
    }
  } catch (e) {
    console.error(e);
  }
};
